import { Boundaries } from "@planzone/core";
import { State } from "./types";
import { Identifiable, List } from "@planzone/dto";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { calculateAdvancement } from "../../utils/calculateAdvancement";
import { getProjectState } from "./utils";

function iterateList(list: Identifiable<List>): Identifiable<List> {
  return {
    ...list,
    tasks: list.tasks.map(calculateAdvancement),
    subLists: list.subLists.map(iterateList),
  };
}

function handleSuccess(
  state: State,
  data: Boundaries["retrieveLists"]["success"],
): State {
  const { index, result } = getProjectState(state, data);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...result,
          request: setRequestStateToSuccess(),
          lists: iterateList(data.lists),
          callCount: result.callCount + 1,
          canRetrieveNextProjects: false,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          ...result,
          callCount: 1,
          request: setRequestStateToSuccess(),
          lists: data.lists,
          canRetrieveNextProjects: false,
        },
      ];
}

export { handleSuccess };
